import { render } from "./App.vue?vue&type=template&id=638018df"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=638018df&lang=css"

import exportComponent from "/home/herrera/Documentos/sacvi3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__